import Spinner from 'src/javascripts/components/utilities/Spinner';
import BuildChartUrl from 'src/javascripts/components/charts/url/BuildChartUrl';
import SetChartTotal from 'src/javascripts/components/charts/actions/SetChartTotal';
import CreateChartLegend from 'src/javascripts/components/charts/legend/CreateChartLegend';

export default class {

  constructor(el) { 
    this.el = el; 
    this.chartId = this.el.attr('id');
  }

  getData() {

    // Set chart element id
    const chartId = this.el.attr('id');

    // Set a spinner to indicate chart loading
    Spinner(this.el);

    // Get data by data attribute or url
    let chartData = this.el.data('chart-data');
    if (typeof chartData !== 'undefined') {return chartData}

    // Set record to get data for and display in chart
    let displayRecord = this.el.attr('data-display-record')

    // Return null if no display record present
    if (typeof displayRecord === 'undefined') {return null;}

    // Set record to get data for and display in chart
    const record = JSON.parse(displayRecord);

    // Build url
    const url = BuildChartUrl(chartId, record);

    // Get data
    return $.getJSON(url);
  }


  render() {}
    // handled in sub-classes

  setUp(chart) {

    // Return if no chart available (don't attempt to set up below)
    if (typeof chart === 'undefined') {return;}

    // Set name and total at top of chart
    SetChartTotal(chart, chart.data()[0].id);

    // Set chart data to allow for accessing chart programmatically (used to allow tables to add/remove data)
    // Also allows for destroying chart before Turbo cache
    // https://stackoverflow.com/questions/25765596/how-to-get-object-reference-from-selector-for-c3-js-charts
    let chartId = '#' + $(chart.element).attr('id');
    $(chartId).data('c3-chart', chart);

    // Get selected records to show in legend
    // Causing issues when before other functions above; appears to be returning for net-impact and returns chart
    // and not running functions after it
    CreateChartLegend(chart);

    // Remove spinner
    $(chart.element).find('.spinner-container').remove();

    return chart;
  }

};

